import {
  getEffectiveContractSize,
  getEffectiveMinContractIncrement,
  getEffectiveQuantityPrecision,
  getProduct,
} from '#/products/domain';
import {
  parseFormattedFloat,
  unformatDecimal,
} from '@paradigm/utils/formatDecimal';
import { formatProductQty } from '#/unified-rfqs/ui/decimal-format';
import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';
import { isDatedInstrument } from '#/unified-rfqs/ui/rfqs/legs-functions';

export default function quantityView(
  value: string,
  [firstLeg]: readonly DrfqLeg[],
) {
  const product = getProduct(firstLeg!.product_code);
  const isDated = isDatedInstrument(firstLeg!.instrument_name);
  const unformattedQty = unformatDecimal(value);

  return {
    value,
    precision: getEffectiveQuantityPrecision(product, isDated),
    error: validateQuantityErrors(unformattedQty, product, isDated),
  };
}

export const validateQuantityErrors = (
  quantity: string,
  product: ReturnType<typeof getProduct>,
  isDated: boolean,
): string | undefined => {
  if (quantity === '') return;
  const minContractIncrement = getEffectiveMinContractIncrement(
    product,
    isDated,
  );

  const formattedNormalizedValue = formatProductQty(
    quantity,
    product.code,
    false,
    isDated,
  );
  const floatValue = parseFormattedFloat(formattedNormalizedValue);

  const minIncrement =
    minContractIncrement * getEffectiveContractSize(product, isDated);
  if (!Number.isInteger(minIncrement)) return;

  const isValidMinIncrement = floatValue % minIncrement === 0;
  if (isValidMinIncrement) return;

  return `${formattedNormalizedValue} is not a valid increment of ${minIncrement}`;
};
